import { render } from "./SectionTagCard.vue?vue&type=template&id=28256c43&scoped=true"
import script from "./SectionTagCard.vue?vue&type=script&lang=js"
export * from "./SectionTagCard.vue?vue&type=script&lang=js"

import "./SectionTagCard.vue?vue&type=style&index=0&id=28256c43&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28256c43"]])

export default __exports__